import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '@/db/db';
import type { InboxStatus, Uuid } from '@/domain/types';

/** Statuses that count as "waiting for the user" in the Att göra badge. */
export const OPEN_INBOX_STATUSES: readonly InboxStatus[] = ['new', 'processing', 'ready', 'check', 'needs_you', 'error'];

/** Number of open inbox items for the company (the nav badge). */
export function useInboxCount(companyId: Uuid | null | undefined): number {
  return (
    useLiveQuery(async () => {
      if (!companyId) return 0;
      return db.inboxItems
        .where('[companyId+status]')
        .anyOf(OPEN_INBOX_STATUSES.map((s) => [companyId, s]))
        .count();
    }, [companyId]) ?? 0
  );
}
